<template>
  <div v-if="user && authorized && chatChecked && toCompanyId && fromCompanyId && toCompanyUuid">
    <!-- :variant="chatMessagesCount && chatMessagesCount > 0 ? 'warning' : 'primary'" -->
    <BushelBtn
      variant="primary"
      :flat="showingStoreFrontChatWindow ? false : true"
      :ripple="false"
      :class="btnClass"
      :style="btnStyle"
      class="mr-1"
      @click="triggerStoreFrontChatWindow"
    >
      <span class="sr-only">Open Chat</span>
      <i class="far fa-comments" style="font-size: 26px" :style="iconStyle" />
      <!--
      <BBadge
        class="badge position-absolute badge-pill text-white text-small pl-1 pr-1 pt-1"
        :variant="chatMessagesCount && chatMessagesCount > 0 ? 'warning' : 'primary'"
        style="right: -5px; top: 11px"
      >
        <span v-if="chatMessagesCount && chatMessagesCount > 0">
          {{ chatMessagesCount }}
        </span>
      </BBadge>
      -->
    </BushelBtn>
    <StoreFrontChatWindow
      v-if="showingStoreFrontChatWindow"
      :key="storeFrontChatWindowKey"
      :show="showingStoreFrontChatWindow"
      :authorized="authorized"
      :chat="chatFound"
      :user="user"
      :loading="loading"
      :refresh="refresh"
      :invoices-available="invoicesAvailable"
      :invoices-loaded="invoicesLoaded"
      :loading-invoices="loadingInvoices"
      :from-company="currentCompany"
      :from-company-id="fromCompanyId"
      :to-company-id="toCompanyId"
      :to-company-name="toCompanyName"
      :to-company-uuid="toCompanyUuid"
      @hide="closeStoreFrontChatWindow"
      @started-new-chat-and-message="startedNewChatAndMessage"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as api from "@/services/api";
import StoreFrontChatWindow from "@/components/chat/StoreFrontChatWindow.vue";
import getAvailableInvoicesForChat from "@/services/chat/chat";

export default {
  name: "StoreFrontChat",
  components: {
    StoreFrontChatWindow,
  },
  props: {
    authorized: { type: Boolean, default: false },
    user: { type: Object, required: true },
    toCompanyId: { type: Number, default: null },
    toCompanyUuid: { type: String, default: null },
    toCompanyName: { type: String, default: null },
    fromCompanyId: { type: Number, default: null },
    btnClass: { type: String, default: null },
    btnStyle: { type: String, default: null },
    iconStyle: { type: String, default: null },
    checkForUnread: { type: Boolean, default: false },
  },
  data() {
    return {
      chatChecked: false,
      chatFound: null,
      showingStoreFrontChatWindow: false,
      storeFrontChatWindowKey: 121212,
      chatMessagesCount: 0,
      loading: false,
      refresh: false,
      invoicesAvailable: [],
      loadingInvoices: false,
      invoicesLoaded: false,
    };
  },
  computed: {
    // ...mapState({
    //   snackbar: (state) => state.ui.snackbar,
    // }),
    ...mapGetters({
      currentCompany: "companies/currentCompany",
    }),
    notificationsChannelName() {
      // if (this.toCompanyUuid) {
      //   return `company-notifications.${this.toCompanyUuid}`;
      // }
      if (this.currentCompany && this.currentCompany.uuid) {
        return `company-notifications.${this.currentCompany.uuid}`;
      }
      return null;
    },
  },
  watch: {
    // snackbar: {
    //   deep: true,
    //   // handler(snackbar) {
    //   //   if (snackbar.message && snackbar.message != "") {
    //   //     this.makeToast(snackbar.message, snackbar.variant, snackbar.title);
    //   //   }
    //   // },
    // },
    currentCompany(newVal, oldVal) {
      if (newVal != oldVal) {
        if (this.authorized) {
          this.setupChat();
        }
      }
    },
  },
  created() {},
  mounted() {
    if (this.authorized) {
      this.setupChat();
    }
  },
  beforeUnmount() {
    if (this.authorized) {
      // this.leaveNotificationsChannel(); // Dont leave it, the sidebar and header might be using it...
    }
  },
  updated() {},
  methods: {
    // ...mapActions({
    //   setSnackbar: "ui/setSnackbar",
    // }),
    getAvailableInvoicesForChat,
    // makeToast(message, variant = null, title = null) {
    //   this.$bvToast.toast(message, {
    //     title,
    //     headerClass: title ? "" : variant == "danger" ? "" : "d-none",
    //     variant,
    //     solid: true,
    //     autoHideDelay: 3000,
    //     toastClass: "toast-width",
    //     toaster: "b-toaster-bottom-right",
    //     noAutoHide: variant == "danger",
    //   });
    //   this.setSnackbar({ variant: null, message: null, title: null });
    // },
    async setupChat() {
      if (this.checkForUnread) {
        await this.checkCompanyChatNotifications();
      } else {
        this.chatChecked = true;
      }
      // await this.runCompanyNotificationsListener();
    },
    async checkCompanyChatNotifications() {
      const self = this;
      const data = {
        buyerCompanyId: self.fromCompanyId,
        vendorCompanyId: self.toCompanyId,
      };
      await api.post("company-chat/storefront-chat-unread-notifications", data).then(
        (response) => {
          if (response && response.data && response.data.code == 200) {
            if (
              self.chatFound &&
              self.chatFound.id &&
              response.data.data &&
              response.data.data.chatRoom &&
              response.data.data.chatRoom.id &&
              self.chatFound.id != response.data.data.chatRoom.id
            ) {
              self.chatFound = response.data.data.chatRoom;
            }
            if (!self.chatFound || self.chatFound == null) {
              self.chatFound = response.data.data.chatRoom;
            }
            // Dont leave it, the sidebar and header might be using it...
            // self.chatMessagesCount = window.Echo.leave          // if (response.data.data.chatRoom && response.data.data.chatRoom.chat_messages) {
            //   self.chatMessagesCount = response.data.data.chatRoom.chat_messages.length;
            // }
          } else {
            // self.setSnackbar({ variant: "danger", title: "Error", message: "Error checking chat notifications" });
          }
        },
        (error) => {
          // self.setSnackbar({ variant: "danger", title: "Error", message: "Error checking chat notifications" });
        },
      );
      self.chatChecked = true;
    },
    async runCompanyNotificationsListener(oldUuid = null) {
      const self = this;
      if (oldUuid) {
        // await window.Echo.leave(`company-notifications.${oldUuid}`); // Dont leave it, the sidebar and header might be using it...
      }
      if (self.notificationsChannelName) {
        // await window.Echo.leave(self.notificationsChannelName); // Dont leave it, the sidebar and header might be using it...
        await window.Echo.private(self.notificationsChannelName).listen("CompanyNotificationUpdated", (event) => {
          if (event.type == "chat-message") {
            self.handleCompanyNotification(event);
          }
        });
      }
    },
    async handleCompanyNotification(event) {
      const self = this;
      const originalUnreadChatsCount = self.chatMessagesCount;
      if (event && event.data && event.data.roomUuid) {
        if (self.chatFound && self.chatFound.uuid) {
          if (self.chatFound.uuid == event.data.roomUuid) {
            await self.checkCompanyChatNotifications();
          } else {
            //
          }
        } else {
          await self.checkCompanyChatNotifications();
        }
      } else {
        self.checkCompanyChatNotifications();
      }
      if (originalUnreadChatsCount < self.chatMessagesCount && !this.showingStoreFrontChatWindow) {
        // self.setSnackbar({
        //   variant: "warning",
        //   message: "New Chat Message",
        //   duration: 5000,
        // });
      }
    },
    async triggerStoreFrontChatWindow() {
      this.getAvailableInvoices();
      this.checkCompanyChatNotifications();
      this.storeFrontChatWindowKey += 1;
      this.showingStoreFrontChatWindow = true;
    },
    closeStoreFrontChatWindow() {
      this.showingStoreFrontChatWindow = false;
      if (this.chatFound && this.chatFound.uuid) {
        // window.Echo.leave(`chat.${this.chatFound.uuid}`); // Dont leave it, the sidebar and header might be using it...
      }
    },
    leaveNotificationsChannel() {
      // window.Echo.leave(this.notificationsChannelName); // Dont leave it, the sidebar and header might be using it...
    },
    async startedNewChatAndMessage(data) {
      const self = this;
      await api.post("company-chat/start-chat", data).then(
        (response) => {
          if (response && response.data && response.data.code == 201) {
            const chat = response.data.data.chatRoom;
            self.chatFound = chat;
            self.refresh = true;
            setTimeout(() => {
              self.refresh = false;
            }, 1);
          } else {
            // self.setSnackbar({ variant: "danger", title: "Error", message: "Error creating new company chat" });
          }
        },
        (error) => {
          // self.setSnackbar({ variant: "danger", title: "Error", message: "Error creating new company chat" });
        },
      );
      self.checkCompanyChatNotifications();
    },
    async getAvailableInvoices() {
      if (!this.toCompanyId || !this.fromCompanyId || !this.user || !this.authorized || !this.fromType) {
        return false;
      }
      this.loadingInvoices = true;
      const response = await this.getAvailableInvoicesForChat({
        buyerCompanyId: this.fromCompanyId,
        sellerCompanyId: this.toCompanyId,
        requestorType: "buyer",
        requestorCompanyId: this.fromCompanyId,
      });
      if (response && response.data && response.data.code == 200 && response.data.data && response.data.data.invoices) {
        this.invoicesAvailable = response.data.data.invoices;
        this.invoicesLoaded = true;
      } else {
        // this.setSnackbar({ variant: "danger", title: "Error", message: "Error getting chat invoices" });
      }
      this.loadingInvoices = false;
      return true;
    },
  },
};
</script>

<style scoped></style>

<style lang="scss" scoped></style>
